<template>
  <header class="page-header publication-header">
    <BranchShape v-scroll:reveal="{ delay: 75 }" class="layout-cta__branch" color="white" :opacity="0.4" header />

    <section class="page-header__container">
      <BreadCrumbs />

      <h1 v-if="publication" v-scroll:reveal="{ delay: 50 }" class="publication-header__banner">
        {{ publication.title }}
      </h1>

      <div v-if="publication" class="publication-header__meta">
        <RouterLink
          v-scroll:reveal="{ delay: 150 }"
          :to="{ name: 'publication-index', query: { type } }"
          class="tag -float -small"
        >
          <SvgIcon :id="icon" />
          {{ tag }}
        </RouterLink>

        <section class="publication-header__submeta">
          <span v-scroll:reveal="{ delay: 200 }" class="publication-header__data">
            <SvgIcon id="content-date" />
            <p>{{ formattedDate }}</p>
          </span>

          <span v-scroll:reveal="{ delay: 225 }" class="publication-header__data -small-icon">
            <SvgIcon id="author" />
            <p>{{ authors }}</p>
          </span>

          <span v-scroll:reveal="{ delay: 250 }" class="publication-header__data">
            <SvgIcon id="time" />
            <p>{{ readingTime }} min</p>
          </span>
        </section>
      </div>
    </section>
  </header>
</template>

<script>
import moment from 'moment'
import { getReadingTime } from '@/helpers/content-formatting'
import { typeTagMap, typeIconMap } from '@/helpers/type-maps'

export default {
  name: 'PublicationSingleHeader',
  props: {
    publication: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      typeTagMap,
      typeIconMap
    }
  },
  computed: {
    authors() {
      return this.publication && this.publication.authors
        ? this.publication.authors
            .map(authorId => this.$wp.authorsById[authorId].name)
            .filter(Boolean)
            .join(', ')
        : null
    },
    type() {
      return this.publication ? this.publication.type : null
    },
    tag() {
      return (this.publication && this.typeTagMap[this.publication.type]) || null
    },
    icon() {
      return (this.publication && this.typeIconMap[this.publication.type]) || null
    },
    formattedDate() {
      return this.publication ? moment(this.publication.original_publish_date).format('D MMMM YYYY') : null
    },
    readingTime() {
      return this.publication && getReadingTime(this.publication.content)
    }
  }
}
</script>
